import { create } from 'zustand';

import { clientIdService } from '@shared/lib/storage';

type SelectedClientStore = {
  clientId: string | null;
  setClientId: (clientId: string | null) => void;
};

// Reactive mirror of the currently selected client. The durable master is
// `clientIdService` (localStorage), read synchronously by the axios interceptor.
// `setClientId` writes through to both, so there is a single write path used by
// the bootstrap loader and the UI switcher alike.
export const useSelectedClientStore = create<SelectedClientStore>((set) => ({
  clientId: clientIdService.get(),
  setClientId: (clientId) => {
    if (clientId) {
      clientIdService.set(clientId);
    } else {
      clientIdService.remove();
    }

    set({ clientId });
  },
}));
